import React from 'react'
import {BsGithub, BsLinkedin,BsTwitter} from 'react-icons/bs'

function HeaderSocials() {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/guduru-chetan-275a0b19b/' target='_blank' rel='noreferrer'><BsLinkedin/></a>
        <a href='https://www.twitter.com/' target='_blank' rel='noreferrer'><BsTwitter/></a>
        <a href='https://www.github.com/' target='_blank' rel='noreferrer'><BsGithub/></a>
    </div>
  )
}

export default HeaderSocials